<template>
  <div>
    <modal :size="'modal-large full-height-modal-mobile'"
           :close-strict="true"
           @close="$emit('close')"
    >
      <div slot="header">
        <h5 class="font-weight-bold mover-earnings-title">Mover earnings</h5>
      </div>
      <div class="scrollable-body" slot="body">
        <div class="loader-circle" v-show="loading" />
        <div :class="[loading ? 'opacity-2' : '']">
          <div class="col-md-12 mb-2">
            <div v-for="payout in payouts" :key="payout.mover_id" class="row w-full mb-4">
              <div class="col-12">
                <h5 class="text-uppercase strong d-flex align-items-center">
                  {{ payout.mover }}
                  <span v-if="payout.foreman"
                        class="foreman-status-blue"
                  >F</span>
                  <span class="align-content-end ml-3 mt-1">
                    <input type="checkbox" v-model="payout.is_paid" :checked="payout.is_paid" />
                    <label class="ml-2" v-if="payout.is_paid">Paid</label>
                    <label class="ml-2" v-else>Mark as paid</label>
                  </span>
                </h5>
              </div>
              <div class="col-5">
                <div class="select-wrap amount-wrap">
                  <label>Hourly wage</label>
                  <span class="dollar">$</span>
                  <input type="text"
                         class="form-control"
                         v-model="payout.hourly_wage"
                  />
                </div>
              </div>
              <div class="col-7 price-info">
                <label>Tips</label>
                <p class="m-0">$ {{ payout.card_tips }}</p>
              </div>
              <div class="col-5 mt-2">
                <div class="select-wrap amount-wrap">
                  <label>Extras</label>
                  <span class="dollar">$</span>
                  <input type="text"
                         class="form-control"
                         v-model="payout.extras"
                  />
                </div>
              </div>
              <div class="col-7 mt-2">
                <div class="select-wrap">
                  <label>Extras Description</label>
                  <input type="text"
                         class="form-control"
                         v-model="payout.extras_description"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="d-flex justify-content-between mx-3 mt-auto">
        <button class="btn btn-secondary w-50 mr-2" @click="$emit('close')">
          Cancel
        </button>
        <button class="btn btn-primary w-50 ml-2" @click="updateEarnings" :disabled="loading">
          Save
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Modal from './Modal';

export default {
  components: {
    Modal,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
    payouts: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    updateEarnings() {
      this.loading = true;
      const data = [];
      this.payouts.forEach(payout => {
        data.push({
          extras: payout.extras,
          extras_description: payout.extras_description,
          is_paid: payout.is_paid,
          user_id: payout.user_id,
          wage: payout.hourly_wage,
        });
      });
      axios
        .put(`/jobs/${this.id}/payouts`, { ...data })
        .then(() => {
          toastr.success('Successfully updated earnings');
          this.$emit('close');
          this.$emit('updated', this.id);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.scrollable-body {
  max-height: 400px;
  overflow: auto;
}

@media screen and (max-width: 600px) {
  .modal-large {
    height: 100vh !important;
    background-color: red !important;
  }

  .mover-earnings-title {
    text-align: center;
    margin-top: 4rem;
    margin-bottom: 4rem;
    font-size: 1.2rem;
    font-weight: 400 !important;
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MoverWagesModal.vue